<template>
    <transition name="modal-transition">
        <div v-if="local_value">
            <div class="aup-modal-wrapper position-fixed h-100 w-100">
                <div
                    class="position-fixed aup-modal-backdrop"
                    :style="{ backgroundImage: 'url(' + resolveMediaImageURL(modalBgUrl, modalBgGuid, 500) + ')' }"
                    @click="$emit('close')"
                ></div>

                <div class="aup-modal position-relative">
                    <div class="aup-modal-content-wrapper d-flex flex-column">
                        <slot name="content">
                            <h1>content is missing</h1>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import BasePhotoDetails from './BasePhotoDetails';
import { calcRespImageURLMixin } from '@/mixins/mixins.js';

let body = document.body;

export default {
	name: 'BaseModalPhoto',
	mixins: [ calcRespImageURLMixin ],
	components: {
		BasePhotoDetails,
	},
	computed: {},
	props: {
		modalBgGuid: {
			type: String,
			default: null,
		},
		modalBgUrl: {
			type: String,
			default: null,
		},
		showModal: {
			type: Boolean,
			default: false,
		},
		value: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		value(val) {
			this.local_value = val;
		},
		local_value(val) {
			this.toggleBodyFixed();
			this.$emit('input', val);
		},
	},
	data() {
		return {
			local_value: this.value,
		};
	},
	methods: {
        toggleBodyFixed() {
            if (this.local_value) {
				document.body.style.overflow = "hidden";
            } else {
				document.body.style.overflow = "auto";
            }
        },
	},
};
</script>

<style lang="scss">
@import '../../assets/scss/all.scss';

.aup-modal-open {
	overflow: hidden;
}

.aup-modal-backdrop {
	opacity: 1 !important;
	left: -5vw;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-size: cover;
	filter: blur(20px) brightness(50%);
	backdrop-filter: blur(20px);
	width: 110vw;
	height: 100%;
	transform: scale(1.2);
	background-color: rgba(0, 0, 0, 0.3);
	transition: opacity 0.3s ease;
}

.aup-modal-wrapper {
	z-index: map-get($zindices, modal);
	position: fixed;
	top: 0;
	left: 0;
	overflow-y: scroll;
	cursor: default;
}

.aup-modal-content-wrapper {
	margin-left: auto;
	margin-right: auto;
	margin-bottom: 5rem;
	width: 80vw;
	max-width: 1160px;
	@include media-breakpoint-down(md) {
		width: 100%;
		padding: 24px 5%;
	}
}

.aup-modal {
	z-index: map-get($zindices, popover);
	margin: $navbar-height auto 0;
	@include media-breakpoint-down(md) {
		margin: 0 auto;
	}
	left: 0;
	overflow-y: auto;
	max-width: 1160px;
}

// TODO: get transitions working
.modal-transition-enter {
	opacity: 0;
}

.modal-transition-leave-active {
	opacity: 0;
}

.modal-transition-enter .aup-modal,
.modal-transition-leave-active .aup-modal {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}
</style>
